import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CommunicationWorkflow from './CommunicationWorkflow';
import EmailPreview from './EmailPreview';
import SnippetAttributes from './SnippetAttributes';
import UserEmailWorkflowDuck from '../../ducks/UserEmailWorkflowDuck';
import classNames from 'classnames';

const userEmailWorkflowActions = new UserEmailWorkflowDuck().actions();

class UserEmailWorkflow extends React.Component {
  static propTypes = {
    customer: PropTypes.object,
    form: PropTypes.object,
    model: PropTypes.object,
    page: PropTypes.number.isRequired,
    previewContent: PropTypes.object,
    previewRecipientId: PropTypes.string,
    recipients: PropTypes.array.isRequired,

    getCustomer: PropTypes.func.isRequired,
    getTokens: PropTypes.func.isRequired,
    sendEmail: PropTypes.func,
    setPreviewRecipientId: PropTypes.func,
    validateSnippet: PropTypes.func.isRequired
  };

  static defaultProps = {
    customer: {},
    form: {},
    model: {},
    page: 0,
    previewContent: {},
    previewRecipientId: '',
    recipients: [],

    getCustomer: () => false,
    getTokens: () => false,
    sendEmail: () => false,
    setPreviewRecipientId: () => false,
    validateSnippet: () => false
  };

  render() {
    const {
      model,
      page,
      recipients
    } = this.props;

    return <CommunicationWorkflow
      actions={userEmailWorkflowActions}
      baseModel="userEmailWorkflow.model"
      components={this.components()}
      confirmation={
        <EmailConfirm
          className="communication-workflow-modal-email-confirm"
          formPrefix=".email"
          recipients={model.email.recipients}
        />
      }
      header="Send Email"
      hideContactSelect={true}
      ids={recipients}
      page={page}
      recipientFilter={this.filterRecipients}
      communicationType={'email'}
      combineFamilyContacts={model.contacts && model.contacts.combine_family_contacts}
    />
  }

  components() {
    const {
      form,
      model,
      previewContent,
      previewRecipientId,
      setPreviewRecipientId
    } = this.props;

    return [
      <SnippetAttributes
        className="communication-workflow-modal-form"
        prefix=""
        formPrefix=".email.snippet"
        model={model.email.snippet}
        form={form.email.snippet}
        froalaOptions={{
          scrollableContainer: '.communication-workflow-modal-form'
        }}
        fields={[
          {
            displayName: 'Reply to',
            canonicalName: 'reply_to'
          },
          {
            displayName: 'Subject',
            canonicalName: 'subject'
          },
        ]}
        onSubmit={this.handleAttributesSubmit}
        communicationType={'email'}
      />,
      <EmailPreview
        className="communication-workflow-modal-email-preview"
        snippet={model.email.snippet}
        recipients={model.email.recipients}
        formPrefix=".email"
        onSubmit={this.handlePreviewSubmit}
        previewContent={previewContent}
        previewRecipientId={previewRecipientId}
        setPreviewRecipientId={setPreviewRecipientId}
        userMailer={true}
        preventSubmit={model.email.recipients.length === 0}
      />
    ];
  }

  componentDidMount() {
    const {
      getCustomer,
      getTokens,
    } = this.props;

    getCustomer();
    getTokens();
  }

  filterRecipients = (recipients) => recipients.filter((recipient) => recipient.email && recipient.name && recipient.id);
  handleAttributesSubmit = (values) => this.props.validateSnippet(values);
  handlePreviewSubmit = (values) => this.props.sendEmail(this.props.model.email.recipients, this.props.model.email.snippet);
}

const EmailConfirm = ({recipients, className}) =>
  <div className={classNames(className, 'communication-modal-confirm')}>
    Email sent to {recipients.length} recipient{recipients.length === 1 ? '' : 's'}.
  </div>;

const mapStateToProps = (state) => {
  return {
    customer: state.customer.object,
    ...state.userEmailWorkflow
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomer: () => dispatch(userEmailWorkflowActions.getCustomer()),
    getTokens: () => dispatch(userEmailWorkflowActions.getTokens()),
    sendEmail: (recipients, snippet) => dispatch(userEmailWorkflowActions.sendEmail(recipients, snippet)),
    setPreviewRecipientId: (contact, snippet) => dispatch(userEmailWorkflowActions.setPreviewRecipientId(contact, snippet)),
    validateSnippet: (snippet) => dispatch(userEmailWorkflowActions.validateSnippet(snippet))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEmailWorkflow);